module.exports = __webpack_public_path__ + "img/Oekoplant.4a728d4b.png";